import { connect } from 'react-redux'

const withStore = connect

export default withStore



// WEBPACK FOOTER //
// ./src/with/Store.js